import request from "../request";
import sysrequest from "../sysrequest";
// 行事曆管理的api

const api = {
  // 行事曆列表查詢
  // /bid/demo_v1/calendar/search/
  calendar_search(data) {
    const obj = {
      url: "/bid/demo_v1/calendar/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 行事曆建立
  // /bid/demo_v1/calendar/create/
  calendar_create(data) {
    const obj = {
      url: "/bid/demo_v1/calendar/create/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
  // 行事曆更新
  // /bid/demo_v1/calendar/update/
  calendar_update(data) {
    const obj = {
      url: "/bid/demo_v1/calendar/update/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 行事曆刪除
  // /bid/demo_v1/calendar/delete/
  calendar_delete(data) {
    const obj = {
      url: "/bid/demo_v1/calendar/delete/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 行事曆匯出
  // /bid/demo_v1/calendar/export/
  calendar_export(data) {
    const obj = {
      url: "/bid/demo_v1/calendar/export/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
